module.exports = __webpack_public_path__ + "media/images/application/template/placeholder-7b28effe2d0b78f871668ac14b5f25d1.png";